import clsx from 'clsx';
import { ReactNode } from 'react';

interface BlockProps {
  className?: string;
  title?: string;
  children?: ReactNode;
}

export const Block = (props: BlockProps) => {
  return (
    <div className={clsx(props.className)}>
      <h2
        className={clsx(
          'text-[#4c4c52] font-bold -tracking-[0.1px] m-0 mb-[20px] text-center uppercase text-base',
          'min-lg:text-lg min-lg:mb-7 min-lg:text-left',
        )}
      >
        {props.title}
      </h2>
      {props.children}
    </div>
  );
};
